// extracted by mini-css-extract-plugin
export default {"wrapper":"AdminEditableTextWrapper_wrapper__V2pL8","button":"AdminEditableTextWrapper_button__cglSQ","buttonWrapper":"AdminEditableTextWrapper_buttonWrapper__XHQ8f"};